var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import PreviewObject from "./PreviewObject";
import PreviewArray from "./PreviewArray";

import PreviewString from "./PreviewString";
import PreviewNumber from "./PreviewNumber";
import PreviewBoolean from "./PreviewBoolean";

import PreviewLocalizedString from "./PreviewLocalizedString";

import PreviewReference from "./PreviewReference";
import PreviewReferenceArray from "./PreviewReferenceArray";

import PreviewMediaArray from "./PreviewMediaArray";
import PreviewMedia from "./PreviewMedia/";

import { isMediaObject, isReferenceObject, isLocalizedString } from "../Schema/utils";

import "./PreviewField.scss";

var templates = {
    "object": PreviewObject,
    "array": PreviewArray,
    "string": PreviewString,
    "number": PreviewNumber,
    "integer": PreviewNumber,
    "boolean": PreviewBoolean,
    "localizedString": PreviewLocalizedString,
    "reference": PreviewReference,
    "referenceArray": PreviewReferenceArray,
    "mediaArray": PreviewMediaArray,
    "media": PreviewMedia
};

var PreviewField = function (_Component) {
    _inherits(PreviewField, _Component);

    function PreviewField() {
        var _temp, _this, _ret;

        _classCallCheck(this, PreviewField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderChild = function (name, index) {}, _this.getClassName = function () {

            var classNames = [];

            classNames.push('admin-preview__field');

            var template = _this.getTemplate();

            if (template) {
                classNames.push('field--' + template);
            }

            return classNames.join(' ');
        }, _this.getTemplate = function () {
            var schema = _this.props.schema;


            var template = void 0;

            if (isMediaObject(schema)) {
                template = "media";
            } else if (schema.type === "array" && isMediaObject(schema.items)) {
                template = "mediaArray";
            } else if (isReferenceObject(schema)) {
                template = "reference";
            } else if (schema.type === "array" && isReferenceObject(schema.items)) {
                template = "referenceArray";
            } else if (isLocalizedString(schema)) {
                template = "localizedString";
            } else if (schema && schema.type) {
                template = schema.type;
            }

            return template;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    PreviewField.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            schema = _props.schema,
            formData = _props.formData;


        var className = this.getClassName();
        var template = this.getTemplate();

        if (template && templates[template]) {
            var FieldTemplate = templates[template];

            return React.createElement(
                FieldTemplate,
                _extends({}, this.props, { className: className }),
                this.props.children
            );
        }

        return this.props.children;
    };

    return PreviewField;
}(Component);

export default PreviewField;